export default __webpack_public_path__ + "static/media/item2.898f10f1.png";